// Formatters + live clock shared by LessonSignupsTab and SignupCard.
import { ref, onMounted, onUnmounted } from 'vue'

// One 1-second ticker for every mounted consumer (cards count down live).
export const now = ref(Date.now())
let users = 0
let timer = null
export function useNowTicker() {
  onMounted(() => { if (users++ === 0) timer = setInterval(() => { now.value = Date.now() }, 1000) })
  onUnmounted(() => { if (--users === 0) clearInterval(timer) })
  return now
}

export const agoLabel = (diffMs) => {
  if (diffMs < 0) return 'just now'
  const totalSecs = Math.floor(diffMs / 1000)
  const secs = totalSecs % 60
  const mins = Math.floor(totalSecs / 60) % 60
  const hrs = Math.floor(totalSecs / 3600) % 24
  const days = Math.floor(totalSecs / 86400)
  if (days >= 1) return days === 1 ? '1d ago' : `${days}d ago`
  if (hrs >= 1) return `${hrs}h ${mins}m ago`
  if (mins >= 1) return `${mins}m ${secs}s ago`
  return `${totalSecs}s ago`
}

export const elapsedTime = (isoStr) => {
  if (!isoStr) return ''
  const ts = isoStr.endsWith('Z') || /[+-]\d{2}:?\d{2}$/.test(isoStr) ? isoStr : isoStr + 'Z'
  return agoLabel(now.value - new Date(ts).getTime())
}

export const fmtSlotDate = (dateStr) => {
  if (!dateStr) return ''
  try {
    const [y, m, d] = dateStr.split('-').map(Number)
    return new Date(y, m - 1, d).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' })
  } catch { return dateStr }
}

export const fmtSlotTime = (timeStr) => {
  if (!timeStr) return ''
  try {
    const [h, m] = timeStr.split(':').map(Number)
    const suffix = h < 12 ? 'am' : 'pm'
    const h12 = h % 12 || 12
    return m === 0 ? `${h12}${suffix}` : `${h12}:${String(m).padStart(2, '0')}${suffix}`
  } catch { return timeStr }
}

export const formatPhone = (phone) => {
  if (!phone) return ''
  const d = phone.replace(/\D/g, '')
  if (d.length === 10) return `(${d.slice(0,3)}) ${d.slice(3,6)}-${d.slice(6)}`
  if (d.length === 11 && d[0] === '1') return `(${d.slice(1,4)}) ${d.slice(4,7)}-${d.slice(7)}`
  return phone
}
